/**
 * @module root/AppShell/QueryPages
 * @summary This module exports the QueryPages component
 */
import React from 'react'
import gql from 'graphql-tag'
import { Query } from 'react-apollo'
import pagesConfig from 'config/pagesConfig'
import Loadable from 'react-loadable'
import { CssBaseline, MuiThemeProvider } from '@material-ui/core'
import Loader from '@zeliot/common/ui/Loader'
import getLoginId from '@zeliot/common/utils/getLoginId'
import {
  defaultTheme,
  darkTheme,
  nonWlDefaultTheme,
  nonWlDarkTheme,
} from '@zeliot/common/constants/theme'
import { createMuiTheme } from '@material-ui/core'
import { SharedSnackbarProvider } from '@zeliot/common/shared/SharedSnackbar/SharedSnackbar.context'
import { DownloadProgressDialogProvider } from '@zeliot/common/shared/DownloadProgressDialog/DownloadProgressDialog.context'
import { setItem, getItem } from '../../../../storage.js'

/**
 * @summary Lazy loaded Appshell component
 */
const AsyncAppShell = Loadable({
  loader: () => import('./AppShell.jsx'),
  loading: () => <Loader fullscreen={true} />,
})

const GET_USER_CONFIGURATION = gql`
  query($loginId: Int!) {
    userConfiguration {
      plan
      config {
        configuration
        theme
      }
    }

    clientDetail(loginId: $loginId) {
      lat
      long
      isERP
      login {
        accountType
        username
        status
      }
    }

    getAllClientAds(clientLoginId: $loginId) {
      imageURL
      redirectURL
      placeOfImage
    }
  }
`

function QueryPages(props) {
  let darkThemeState = localStorage.getItem('isDarkTheme')
  let themeState = darkThemeState === 'true' ? true : false

  const [isDarkTheme, setIsDarkTheme] = React.useState(
    themeState ? themeState : false
  )

  function handleThemeChange(val) {
    localStorage.setItem('isDarkTheme', val)
    setIsDarkTheme(val)
  }

  return (
    <Query query={GET_USER_CONFIGURATION} variables={{ loginId: getLoginId() }}>
      {({ loading, error, data }) => {
        if (loading) return <Loader fullscreen={true} />
        if (error) return <div>Oops</div>
        console.log(
          'data.userConfiguration.plan.features',
          data.userConfiguration.plan.features
        )
        // const pages = data.userConfiguration.plan.features
        //   .concat([
        //     { key: 'OBD_DASHBOARD' },
        //     { key: 'LOCATION_GEO' },
        //     { key: 'ROUTES_GEO' },
        //     { key: 'TRIPS_GEO' },
        //     { key: 'GOOGLE_MAPS_GEOFENCE' },
        //     { key: 'GEOFENCE_BREACH' },
        //     { key: 'AREA_CONFIG' },
        //     { key: 'LOCATION_BREACH' },
        //     { key: 'MONITORING_DASH' },
        //     { key: 'DASHBOARD_OBD_CONFIG' },
        //     { key: 'VEHICLE_STATISTICS' },
        //     data.clientDetail && data.clientDetail.login && data.clientDetail.login.accountType !== 'FM'&& { key: 'MANAGE_FLEET_MANAGERS' },
        //     data.clientDetail && data.clientDetail.login && data.clientDetail.login.accountType !== 'FM'&& { key: 'MANAGE_REGIONS'},

        //   ])
        //   .map((feat) => pagesConfig[feat.key])

        const features = data?.userConfiguration?.plan?.features || []

        const extraPages = [
          { key: 'OBD_DASHBOARD' },
          { key: 'LOCATION_GEO' },
          { key: 'ROUTES_GEO' },
          { key: 'TRIPS_GEO' },
          { key: 'GOOGLE_MAPS_GEOFENCE' },
          { key: 'GEOFENCE_BREACH' },
          { key: 'AREA_CONFIG' },
          { key: 'LOCATION_BREACH' },
          { key: 'MONITORING_DASH' },
          { key: 'DASHBOARD_OBD_CONFIG' },
          { key: 'VEHICLE_STATISTICS' },
          { key: 'FUEL_DASHBOARD_VEHICLE'}
        ];

        if (
          data?.clientDetail?.login?.accountType &&
          data.clientDetail.login.accountType !== 'FM'
        ) {
          extraPages.push({ key: 'MANAGE_FLEET_MANAGERS' })
          extraPages.push({ key: 'MANAGE_REGIONS' })
        }
        const pages = [...features, ...extraPages].map(
          (feat) => pagesConfig[feat.key]
        )
        
        
        const plan = data.userConfiguration.plan.name
        if (data.clientDetail && data.clientDetail.isERP) {
          setItem('isERP', isERP, 'PERSISTENT')
          const { isERP } = data.clientDetail
        }
        // setItem('plan', plan, 'PERSISTENT')
        if (
          data.userConfiguration.config.theme &&
          data.userConfiguration.config.theme.palette
        ) {
          defaultTheme.palette.primary.main =
            data.userConfiguration.config.theme.palette.primary.main
          defaultTheme.palette.primary.light =
            data.userConfiguration.config.theme.palette.secondary.main
          darkTheme.palette.primary.main =
            data.userConfiguration.config.theme.palette.primary.main
          darkTheme.palette.primary.light =
            data.userConfiguration.config.theme.palette.secondary.main

          defaultTheme.palette.secondary.main =
            data.userConfiguration.config.theme.palette.secondary.main
          defaultTheme.palette.secondary.light =
            data.userConfiguration.config.theme.palette.primary.main
          darkTheme.palette.secondary.main =
            data.userConfiguration.config.theme.palette.secondary.main
          darkTheme.palette.secondary.light =
            data.userConfiguration.config.theme.palette.primary.main

          defaultTheme.palette.link.main =
            data.userConfiguration.config.theme.palette.primary.main
          darkTheme.palette.link.main =
            data.userConfiguration.config.theme.palette.primary.main
        } else {
          console.log('no user configuration fetched')
          darkTheme.mode = nonWlDarkTheme.mode
          darkTheme.palette = nonWlDarkTheme.palette
          darkTheme.shadows = nonWlDarkTheme.shadows
          defaultTheme.mode = nonWlDefaultTheme.mode
          defaultTheme.palette = nonWlDefaultTheme.palette
        }
        setItem('plan', plan, 'PERSISTENT')

        return (
          <MuiThemeProvider
            theme={isDarkTheme ? darkTheme : createMuiTheme(defaultTheme)}
          >
            <SharedSnackbarProvider>
              <DownloadProgressDialogProvider>
                <CssBaseline />
                <AsyncAppShell
                  {...props}
                  pages={pages}
                  isDarkTheme={isDarkTheme}
                  onThemeChange={handleThemeChange}
                />
              </DownloadProgressDialogProvider>
            </SharedSnackbarProvider>
          </MuiThemeProvider>
        )
      }}
    </Query>
  )
}

export default QueryPages
